// extracted by mini-css-extract-plugin
export default {"tabs":"investigation_diagnosis_tabs__4LHcX","tab":"investigation_diagnosis_tab__Ftz3C","active":"investigation_diagnosis_active__36ntw"};